import { be } from "./lib/better-errors"

be.initClient()
